import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Oferta1la1Hero } from '../components/oferta1la1/Oferta1la1Hero';
import { Oferta1la1Problem } from '../components/oferta1la1/Oferta1la1Problem';
import { Oferta1la1Curriculum } from '../components/oferta1la1/Oferta1la1Curriculum';
import { Oferta1la1Benefits } from '../components/oferta1la1/Oferta1la1Benefits';
import { Oferta1la1About } from '../components/oferta1la1/Oferta1la1About';
import { Oferta1la1ForWho } from '../components/oferta1la1/Oferta1la1ForWho';
import { Oferta1la1Pricing } from '../components/oferta1la1/Oferta1la1Pricing';
import { Oferta1la1Testimonials } from '../components/oferta1la1/Oferta1la1Testimonials';
import { Oferta1la1FAQ } from '../components/oferta1la1/Oferta1la1FAQ';
export function Oferta1la1Page() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2396">
      <Header data-id="element-2397" />
      <main data-id="element-2398">
        <Oferta1la1Hero data-id="element-2399" />
        <Oferta1la1Problem data-id="element-2400" />
        <Oferta1la1Curriculum data-id="element-2401" />
        <Oferta1la1Benefits data-id="element-2402" />
        <Oferta1la1About data-id="element-2403" />
        <Oferta1la1ForWho data-id="element-2404" />
        <Oferta1la1Pricing data-id="element-2405" />
        <Oferta1la1Testimonials data-id="element-2406" />
        <Oferta1la1FAQ data-id="element-2407" />
      </main>
      <Footer data-id="element-2408" />
    </div>;
}